import { FormsMultilineInput } from '@platform/components';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../Application';
import { useApplicationLocalStorage } from '../application-hook';
import { ApplicationBackground } from '../ApplicationBackground';
import { ApplicationPageContent } from '../components/ApplicationPageContent';
import { NeedHelpButton } from '../components/NeedHelpButton';
import BackgroundImage from '../images/Kathrine-Rossi.svg';

type FormValues = {
  skillsImpact: string;
};
export const SkillsImpactSelection = (props: ApplicationPageProps) => {
  const [showExample, setShowExample] = useState(false);

  const { onBack, onContinue, progress, dataKey } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } = useApplicationLocalStorage(dataKey);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { skillsImpact: getApplicationDataByKey('skillsImpact') },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({ skillsImpact: data.skillsImpact });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      skillsImpact: watch('skillsImpact'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent
        title=' How do you think those skills could benefit a social organization?'
        description='This will help us match you with projects. It won’t be on your profile.'
      >
        <FormsMultilineInput
          control={control}
          placeholder='Type your answer here...'
          rules={{
            maxLength: 500,
            required: 'Tell us more about how your skills can help to continue',
          }}
          characterCount={500}
          formsError={errors.skillsImpact}
          name='skillsImpact'
        />
        <NeedHelpButton
          onClick={() => setShowExample(!showExample)}
          isOpen={showExample}
          helpContent={
            'My project management and data analysis skills can help a social impact organization stay organized, track progress, and measure outcomes. By optimizing workflows and providing insights, I can contribute to more efficient and impactful projects.'
          }
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
